import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getIsAddToCartModalOpen } from '../../state/redux/features/ui/selectors';

const LazyAddToCartModal = React.lazy(
  () => import(/* webpackChunkName: "AddToCartModal" */ './AddToCartModal'),
);

const AdddToCartModalWrapper = () => {
  const isAddToCartModalOpen = useSelector(getIsAddToCartModalOpen);
  return isAddToCartModalOpen ? (
    <Suspense fallback={null}>
      <LazyAddToCartModal />
    </Suspense>
  ) : null;
};

AdddToCartModalWrapper.propTypes = {};

export default AdddToCartModalWrapper;
